import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchWatchLists } from '../../../store/watch-list/action';
import MyWatchList from './component';

const mapStateToProps = ({ watchList, user }) => ({ watchList, user });

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchWatchListsConnect: fetchWatchLists
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MyWatchList);